import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";

function calcUltimaZiLuna(dataImprumut, nrRate) {
  if (!dataImprumut) return null;
  const start = new Date(dataImprumut);
  const year = start.getFullYear();
  const month = start.getMonth() + Number(nrRate);
  // Ultima zi a lunii: ziua 0 a lunii urmatoare
  return new Date(year, month + 1, 0);
}

function fmtDateRO(date) {
  if (!date) return "___";
  const d = String(date.getDate()).padStart(2, "0");
  const m = String(date.getMonth() + 1).padStart(2, "0");
  return `${d}/${m}/${date.getFullYear()}`;
}

export default function RambursareStep({ data, errors, update }) {
  const allRateOptions = [
    { value: "2", label: "2 rate" },
    { value: "3", label: "3 rate" },
    { value: "6", label: "6 rate" },
    { value: "12", label: "12 rate" },
    { value: "24", label: "24 rate" },
    { value: "36", label: "36 rate" },
  ];

  // Calculez data restituirii automat pentru rate
  const dataRestituireCalculata = data.modalitateRestituire === "rate" && data.dataImprumut
    ? calcUltimaZiLuna(data.dataImprumut, data.nrRate || 12)
    : null;

  // Calculez rata estimata
  const suma = Number(data.sumaImprumut) || 0;
  const nrRate = Number(data.nrRate) || 12;
  const rataEstimata = data.modalitateRestituire === "rate" && suma > 0
    ? (suma / nrRate).toLocaleString("ro-RO", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : null;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField label="Data acordarii imprumutului" value={data.dataImprumut} onChange={update("dataImprumut")} type="date" required half error={errors.dataImprumut} />

      {data.modalitateRestituire !== "rate" && (
        <InputField label="Data restituirii" value={data.dataRestituire} onChange={update("dataRestituire")} type="date" required half error={errors.dataRestituire} />
      )}

      <SelectField
        label="Modalitate de restituire"
        value={data.modalitateRestituire}
        onChange={update("modalitateRestituire")}
        options={[
          { value: "integral", label: "Integral la scadenta (rata unica)" },
          { value: "rate", label: "In rate lunare egale" },
        ]}
      />

      {data.modalitateRestituire === "rate" && (
        <>
          <SelectField
            label="Numar de rate"
            value={data.nrRate}
            onChange={update("nrRate")}
            options={allRateOptions}
            half
          />
          <div style={{ flex: "1 1 48%", minWidth: "220px" }}>
            <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#4a3f35", marginBottom: "6px", fontFamily: "'DM Sans', sans-serif", letterSpacing: "0.02em" }}>
              Data ultimei rate (calculata automat)
            </label>
            <div style={{ padding: "12px 16px", border: "2px solid #e8e0d4", borderRadius: "10px", fontSize: "15px", fontFamily: "'DM Sans', sans-serif", backgroundColor: "#f5f3ef", color: "#2d2418" }}>
              {fmtDateRO(dataRestituireCalculata)}
            </div>
          </div>
          <p style={{ width: "100%", fontSize: "11px", color: "#8a7e70", margin: "-8px 0 0 0" }}>
            Ratele sunt scadente in ultima zi a fiecarei luni.{rataEstimata && <> <strong>Rata estimata: {rataEstimata} {data.valuta || "RON"}</strong></>}
          </p>
        </>
      )}
    </div>
  );
}
